import ChoiceInputField from './ChoiceInputField.vue';

export default ChoiceInputField; // eslint-disable-line
